import type { CompareFormat } from './schemas';

export interface CompareParts {
  /** false pour 'absolute' : aucun indicateur de variation. */
  showDelta: boolean;
  /** Comment rendre le delta. */
  kind: 'percent' | 'diff' | 'both';
  /** Variation en %, arrondie 1 décimale ; null si `previous` <= 0 ou null. */
  percent: number | null;
  /** Différence absolue `current - previous` ; null si `previous` null. */
  diff: number | null;
}

/** Calcule les primitives de comparaison selon le format choisi. Fonction pure. */
export function computeCompare(
  current: number,
  previous: number | null,
  format: CompareFormat,
): CompareParts {
  const valid = Number.isFinite(current);
  const percent =
    valid && previous !== null && previous > 0
      ? Number((((current - previous) / previous) * 100).toFixed(1))
      : null;
  const diff = valid && previous !== null ? current - previous : null;
  return {
    showDelta: format !== 'absolute',
    kind: format === 'diff' ? 'diff' : format === 'both' ? 'both' : 'percent',
    percent,
    diff,
  };
}
